module.exports = __webpack_public_path__ + "img/message.07411d3c.svg";